import { render, staticRenderFns } from "./AEditor.vue?vue&type=template&id=546afba9&"
import script from "./AEditor.vue?vue&type=script&lang=js&"
export * from "./AEditor.vue?vue&type=script&lang=js&"
import style0 from "./AEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports